import { useTranslation, useDialogStore } from '../store';
import { QRScanner } from './dialogs/QRScanner';

const NoData = ({ message }: { message?: string }) => {
  const { t } = useTranslation();
  const { openDialog } = useDialogStore();

  const handleRefresh = () => {
    window.location.reload();
  };
  
  const handleQRScanner = (e) => {
    e.preventDefault();
    openDialog(QRScanner, {});
  };

  return (
    <div className="tab-content">
      <div className="no-data">{message || t('noData')}</div>
      <br/>
      <button 
        type="button" 
        className="btn btn-outline-secondary"
        onClick={handleRefresh}
      >
        <span className="glyphicon glyphicon-refresh"></span> {t('refresh')}
      </button>
      <br/>
      <br/>
      <button 
        type="button" 
        className="btn btn-outline-secondary"
        onClick={handleQRScanner}
      >
        <span className="glyphicon glyphicon-qrcode"></span> {t('qr')}
      </button>
    </div>
  );
};

export default NoData;